<template>
  <v-card outlined class="pa-4">
    <div class="subtitle-1 font-weight-bold mb-3 primary--text">Detalle de Educación / Grado de Instrucción</div>
    <v-row dense>
      <v-col cols="12" md="6" class="s-col-form">
        <s-select-definition
          v-model="levelID"
          :def="1066"
          label="Nivel Educativo obtenido*"
          @input="emitValue"
          :addCustom="$fun.isAdmin()"
                    :customFields="[
                      {
                        key: 'DedDescription',
                        label: 'País',
                        required: true,
                        cols: 6,
                      },
                      {
                        key: 'DedFormat',
                        label: 'Gentilicio',
                        required: true,
                        cols: 6,
                      },
                      {
                        key: 'DedAbbreviation',
                        label: 'Abreviación',
                        required: true,
                        cols: 6,
                      },
                      {
                        key: 'DedHelper',
                        label: 'Cód. T4 Sunat',
                        required: true,
                        cols: 6,
                      },
                      {
                        key: 'DedHelper2',
                        label: 'Cód. T26 Sunat',
                        required: true,
                        cols: 6,
                      },
                    ]"
        />
      </v-col>
      <v-col cols="12" md="6" class="s-col-form">
        <s-select-educational-institution
          v-model="ediCode"
          id="EdiCode"
          label="Institución Educativa*"
          @input="onInstitutionChange"
        />
      </v-col>
      <v-col cols="12" md="6" class="s-col-form">
        <s-select-educational-major
          v-model="edmCode"
          id="EdmCode"
          label="Carrera Profesional*"
          :edi-code="ediCode"
          :disabled="!ediCode"
          @input="emitValue"
        />
      </v-col>
      <v-col cols="12" md="3" class="s-col-form">
        <s-text
          type="number"
          label="Año de Ingreso"
          v-model="yearAdmission"
          maxlength="4"
          @input="emitValue"
        />
      </v-col>
      <v-col cols="12" md="3" class="s-col-form">
        <s-text
          type="number"
          label="Año de Egreso (o actual)"
          v-model="yearGraduation"
          maxlength="4"
          @input="emitValue"
        />
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import SText from '@/components/Utils/SText.vue';
import SSelectDefinition from '@/components/Utils/SSelectDefinition.vue';
import SSelectEducationalInstitution from '@/components/Utils/SSelectEducationalInstitution.vue';
import SSelectEducationalMajor from '@/components/Utils/SSelectEducationalMajor.vue';

export default {
  name: 'SLevelEducationComponent',
  components: {
    SText,
    SSelectDefinition,
    SSelectEducationalInstitution,
    SSelectEducationalMajor
  },
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      levelID: null,
      ediCode: null,
      edmCode: null,
      yearAdmission: null,
      yearGraduation: null,
      isInternalChange: false
    };
  },
  watch: {
    value: {
      handler(newVal) {
        if (this.isInternalChange) {
          this.isInternalChange = false;
          return;
        }
        if (newVal) {
          try {
            const data = JSON.parse(newVal);
            this.levelID = data.LveID || null;
            this.ediCode = data.EdiCode || null;
            this.edmCode = data.EdmCode || null;
            this.yearAdmission = data.YearAdmission || null;
            this.yearGraduation = data.Year || null;
          } catch (e) {
            console.error('Error parsing SLevelEducationComponent value JSON:', e);
          }
        } else {
          this.reset();
        }
      },
      immediate: true
    }
  },
  methods: {
    onInstitutionChange(val) {
      this.ediCode = val;
      // Reset career when institution changes
      this.edmCode = null;
      this.emitValue();
    },
    emitValue() {
      if (!this.levelID && !this.ediCode && !this.edmCode && !this.yearAdmission && !this.yearGraduation) {
        this.isInternalChange = true;
        this.$emit('input', '');
        return;
      }
      
      const payload = {
        LveID: this.levelID ? parseInt(this.levelID) : null,
        EdiCode: this.ediCode || null,
        EdmCode: this.edmCode || null,
        YearAdmission: this.yearAdmission ? parseInt(this.yearAdmission) : null,
        Year: this.yearGraduation ? parseInt(this.yearGraduation) : null
      };
      
      this.isInternalChange = true;
      this.$emit('input', JSON.stringify(payload));
    },
    reset() {
      this.levelID = null;
      this.ediCode = null;
      this.edmCode = null;
      this.yearAdmission = null;
      this.yearGraduation = null;
    }
  }
};
</script>

<style scoped>
</style>
